import { useNavigate } from 'react-router-dom';

const SolutionsShowcase = () => {
  const navigate = useNavigate();

  const solutions = [
    {
      title: 'STEM Lab Setup',
      description: 'Complete infrastructure with hands-on learning modules',
      icon: 'ri-flask-line',
      color: 'from-blue-500 to-cyan-500',
    },
    {
      title: 'AI & Robotics Lab',
      description: 'Advanced technology integration for future-ready students',
      icon: 'ri-robot-line',
      color: 'from-purple-500 to-pink-500',
    },
    {
      title: 'Teacher Training',
      description: 'Comprehensive enablement programs for educators',
      icon: 'ri-user-star-line',
      color: 'from-orange-500 to-red-500',
    },
    {
      title: 'Innovation Workshops',
      description: 'Project-based learning and design thinking sessions',
      icon: 'ri-lightbulb-line',
      color: 'from-green-500 to-teal-500',
    },
  ];

  const handleContactClick = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      const offset = 80; // Account for fixed navbar
      const top = contactSection.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="container mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Our Solutions
          </h2>
          <p className="text-base text-gray-600 max-w-3xl mx-auto">
            Comprehensive STEM education solutions designed for Indian schools
          </p>
        </div>

        {/* Solutions Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {solutions.map((solution, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer"
              onClick={() => navigate('/solutions')}
            >
              <div
                className={`w-12 h-12 rounded-xl bg-gradient-to-br ${solution.color} flex items-center justify-center mb-5`}
              >
                <i className={`${solution.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">
                {solution.title}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                {solution.description}
              </p>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center">
          <button
            onClick={handleContactClick}
            className="px-7 py-3 bg-blue-600 text-white text-sm font-semibold rounded-lg hover:bg-blue-700 transition-all shadow-xl hover:shadow-2xl"
          >
            Contact Us
          </button>
        </div>
      </div>
    </section>
  );
};

export default SolutionsShowcase;
